import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO65 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK006-5.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO65
